import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Testimonianze" title="Cosa dice chi lo utilizza" width="narrow" data-id="element-237" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-4xl divide-y divide-blue-200/70" data-id="element-238" data-mp="3azjc3rzaca9k">
        {testimonials.map(item => <li key={item.author} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-239" data-mp="36zr0f6elhnzz">
            <div className="flex items-start gap-3" data-id="element-240" data-mp="2x0jmah01dpbt">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-241" data-mp="2x11so6gexjxg">
                {item.initials}
              </span>
              <span data-id="element-242" data-mp="v8wsy8so9ic6">
                <span className="flex gap-0.5" aria-label="5 stelle su 5" data-id="element-243" data-mp="v7c7r9s8zbqz">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-244" data-mp="h5os1hpjsial" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-245" data-mp="79lezgt5qz8v">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-246" data-mp="zwpl5p3zljm8">{item.role}</span>
                {item.city && <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-247" data-mp="14vsjyrtditlr">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-248" data-mp="q7ejgnjfjh8d" />
                    {item.city}
                  </span>}
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-249" data-mp="1ius7fw55h2gc">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}